import React from 'react';
import { Heart, Leaf, Activity, Zap, TrendingUp, Sparkles, SmilePlus, Target } from 'lucide-react';
import { Reveal, Stagger, StaggerItem } from './Reveal';

const services = [
  {
    icon: Heart,
    title: "Sustainable Weight Management",
    description: "Without extreme restriction or rigid diets"
  },
  {
    icon: Activity,
    title: "Gut & Digestive Health",
    description: "Including bloating, acidity, irregular digestion, and low appetite"
  },
  {
    icon: Sparkles,
    title: "PCOS & Hormonal Balance",
    description: "Support through nutrition and lifestyle alignment"
  },
  {
    icon: Zap,
    title: "Improving Energy Levels",
    description: "Reducing fatigue, lethargy, and brain fog"
  },
  {
    icon: TrendingUp,
    title: "Metabolic Health",
    description: "Including improving blood markers such as sugar levels, cholesterol, and nutritional deficiencies"
  },
  {
    icon: SmilePlus,
    title: "Skin Health",
    description: "Linked to lifestyle patterns and hormonal changes"
  },
  {
    icon: Leaf,
    title: "Healthier Relationship with Food",
    description: "Building after repeated dieting cycles"
  },
  {
    icon: Target,
    title: "Long-term Lifestyle Correction",
    description: "Focused on habits that hold up in real life, not short-term fixes"
  }
];

export const ServicesSection = () => {
  return (
    <section 
      id="services"
      className="section-padding grain-texture"
      style={{ background: 'var(--brand-purple-bg)' }}
    >
      <div className="container-custom">
        <Reveal className="max-w-4xl mx-auto text-center mb-20">
          <h2 className="heading-1 text-balance" style={{ color: '#FFFFFF' }}>What we tackle, together</h2>
          <p className="body-large mt-8" style={{ color: 'rgba(255, 255, 255, 0.88)' }}>
            Evidence-based support for your unique health journey
          </p>
        </Reveal>

        <Stagger className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto" stagger={0.08}>
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <StaggerItem
                key={service.title}
                className="premium-card"
                data-testid={`service-card-${index}`}>

                <div 
                  className="w-14 h-14 flex items-center justify-center mb-6"
                  style={{ 
                    background: 'linear-gradient(135deg, #8E5EA0 0%, #A87FC0 100%)',
                    borderRadius: '16px',
                    boxShadow: '0 6px 16px rgba(142, 94, 160, 0.3)'
                  }}
                >
                  <Icon size={24} color="white" strokeWidth={1.75} />
                </div>
                <div className="space-y-3">
                  <h3 className="heading-3">{service.title}</h3>
                  <p className="body-regular">{service.description}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
